import { render, staticRenderFns } from "./StockAddressTemplate.vue?vue&type=template&id=b4c33c2a&scoped=true&"
import script from "./StockAddressTemplate.vue?vue&type=script&lang=js&"
export * from "./StockAddressTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4c33c2a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b4c33c2a')) {
      api.createRecord('b4c33c2a', component.options)
    } else {
      api.reload('b4c33c2a', component.options)
    }
    module.hot.accept("./StockAddressTemplate.vue?vue&type=template&id=b4c33c2a&scoped=true&", function () {
      api.rerender('b4c33c2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Papers/pages/Paper/components/Templates/StockAddressTemplate.vue"
export default component.exports